import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const ListBox = ({ title, subtitle, isMobile, language }: { title: string, subtitle: string, isMobile: boolean, language: any }) => {
    const isArabic = language === 'arabic';
    return (
        <Paper elevation={3} sx={{ width: isMobile ? "90%" : "300px", padding: 1, margin: 2, borderLeft: isArabic ? "none":"7px solid var(--accent-secondary)" ,  borderRight: isArabic ? "7px solid var(--accent-secondary)" : "none", backgroundColor: "var(--section-bg)" }}>
            <Typography variant="h6" fontSize={isMobile ? "13px" : "13px"} fontWeight="bold" textAlign={isArabic ? "right" : "left"} sx={{ color: "var(--text-primary)" }}>{title}</Typography>
            <Typography variant="subtitle1" fontSize={isMobile ? "12px" : "12px"} sx={{ color: "var(--text-primary)" }} textAlign={isArabic ? "right" : "left"}>{subtitle}</Typography>
        </Paper>
    );
};

export default ListBox;
